const initialState = localStorage.getItem("unit") ? JSON.parse(localStorage.getItem("unit")) : []

const unitReducer = (state = initialState, action) => {
    let {type, payload} = action;
    switch (type) {
        case "UPDATE_UNIT":
            localStorage.setItem("unit", JSON.stringify(payload));
            return state;
        default:
            return state;
    }
};

export default unitReducer;